export default {"src":"/_next/static/media/xp.bc4d4e96.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};